import React from 'react';
import { Box } from '@mui/material';
import FilterChip from './FilterChip';
import { FEEDBACK_ON_DEMAND_TYPES } from '../../../constants/feedbackOnDemandTypes';

// Color and label helper functions for feedback on demand types
export const getFeedbackOnDemandTypeLabel = (type) => {
  return type === FEEDBACK_ON_DEMAND_TYPES.ASKING ? 'Asking for Feedback' : 'Giving Feedback';
};

export const getFeedbackOnDemandTypeColors = (type, isSelected) => {
  const isAsking = type === FEEDBACK_ON_DEMAND_TYPES.ASKING;
  const typeColor = isAsking ? '#2E90FA' : '#16A34A';
  
  return {
    backgroundColor: typeColor,
    textColor: isSelected ? 'white' : typeColor, // White when selected, type color when not selected
    borderColor: typeColor
  };
};

const FeedbackOnDemandType = ({ 
  selectedTypes = [], 
  onTypeToggle,
  types = null, // If null, shows all types. If array, shows only specified types
  sx = {} 
}) => {
  // Determine which types to show
  const typesToShow = types || Object.values(FEEDBACK_ON_DEMAND_TYPES);
  
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ...sx }}>
      {typesToShow.map((type) => {
        const typeLabel = getFeedbackOnDemandTypeLabel(type);
        const isSelected = selectedTypes.includes(type);
        const colors = getFeedbackOnDemandTypeColors(type, isSelected);
        
        return (
          <FilterChip
            key={type}
            label={typeLabel}
            isSelected={isSelected}
            onClick={() => onTypeToggle(type)}
            backgroundColor={colors.backgroundColor}
            textColor={colors.textColor}
            borderColor={colors.borderColor}
            showDot={true} // Type filters don't typically need dots
          />
        );
      })}
    </Box>
  );
};

export default FeedbackOnDemandType; 